import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ContentAsset, TemplateCriteria } from '@r1-compass-library/models';
import { LifecycleRuleset } from '@r1-compass-library/models/lifecycle-rules/lifecycle-ruleset.model';

export function validLifecycleRuleValidator(getLifecycleRulesets: () => LifecycleRuleset[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value || Number(value) === 0) {
            return null;
        }
        const rulesets = getLifecycleRulesets();
        if (rulesets.length > 0) {
            const ruleset = rulesets.find(r => r.id === Number(value));
            if (!ruleset || !ruleset.enabled || !ruleset.valid) {
                return { invalidLifecycleRule: true };
            }
        }
        return null;
    };
}

export function validTemplateCriteriaValidator(getTemplateCriteria: () => TemplateCriteria[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value || Number(value) === 0) {
            return null;
        }
        const criteriaList = getTemplateCriteria();
        if (criteriaList.length > 0) {
            const criteria = criteriaList.find(c => c.id === Number(value));
            if (!criteria || !criteria.enabled || !criteria.valid) {
                return { invalidTemplateCriteria: true };
            }
        }
        return null;
    };
}

export function validContentAssetsValidator(
    getUsedAssetIds: () => Set<number>,
    getContentAssets: () => ContentAsset[]
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const usedIds = getUsedAssetIds();
        if (!usedIds || usedIds.size === 0) {
            return null;
        }
        const allAssets = getContentAssets();
        if (allAssets.length > 0) {
            const invalidAssetNames: string[] = [];
            for (const id of usedIds) {
                const asset = allAssets.find(a => a.id === id);
                if (!asset || !asset.enabled || !asset.valid) {
                    invalidAssetNames.push(asset?.name + ` ID: ${id}`);
                }
            }
            if (invalidAssetNames.length > 0) {
                return { invalidContentAssets: { assetNames: invalidAssetNames } };
            }
        }
        return null;
    };
}
